import React, { Component } from 'react';
import { matchPath } from 'react-router';
import Helmet from 'react-helmet';
import './ReviewsList.css';

import AuthService from './AuthService';
import UserNavbar from './UserNavbar';
import SelfSideBar from './SelfSideBar';
import NavBar from './Navbar';
import UserQuery from './UserQuery';
import constants from '../config';
import AuthModalContext from '../contexts/AuthModalContext';

const Auth = new AuthService();

class PostSharesList extends Component {
  static contextType = AuthModalContext;
  constructor() {
    super();
    this.state = {
      shared: [],
    };
    // GUEST NAVBAR
    this.toLogin = this.toLogin.bind(this);
    this.toSignUp = this.toSignUp.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    // USER NAVBAR
    this.handlePost = this.handlePost.bind(this);
    this.handleHome = this.handleHome.bind(this);
    this.handleSelfProfile = this.handleSelfProfile.bind(this);
    this.handleNotifications = this.handleNotifications.bind(this);

    // PAGE FUNCTIONALITY
    this.shared = this.shared.bind(this);
    this.profile = this.profile.bind(this);
  }
  componentWillMount() {
  }

  // Function that always run
  componentDidMount() {
    // this.reviews();
    // console.log(this.props);
    const match = matchPath(this.props.history.location.pathname, {
      path: '/shares/:post_id',
      exact: false,
      strict: false,
    });

    const postId = match.params.post_id;
    // console.log("id", userId);
    this.shared(postId);
  }

  // GUEST NAVBAR
  handleSearch(search) {
    this.setState({
      query: search,
    }, () => {
      this.props.history.push(`/search/${this.state.query}`);
    });
  }

  toLogin() {
    this.context.openAuthModal('login');
  }

  toSignUp() {
    this.context.openAuthModal('signup');
  }
  // NAVBAR ROUTES
  handlePost() {
    this.props.history.push('/sell');
  }
  handleHome() {
    this.props.history.push('/');
  }
  handleSelfProfile() {
    const user = Auth.getProfile();
    this.props.history.push(`/shop/${user.username}`);
  }
  handleNotifications() {
    this.props.history.push('/notifications');
  }

  // PAGE FUNCTIONALITY
  shared(postId) {
    if (Auth.getToken()) { // is user
      const user = Auth.getProfile();
      // Self side bar
      this.profile(user._id);
      Auth.fetch(`${constants.DOMAIN}/api/v1/posts/${postId}/shared`, {
        mode: 'cors',
        method: 'GET',
      })
        .then(res => {
          this.setState({
            shared: res.sharedList.reverse(),
            navbar: <UserNavbar handleSearch={(search) => this.handleSearch(search)} user={Auth.getProfile()} handleSelfProfile={this.handleSelfProfile} handlePost={this.handlePost} handleHome={this.handleHome} handleNotifications={this.handleNotifications} />,    
          });
        //   console.log('favList', res);
        })
        .catch(err => {
          console.log(err);
        });
    } else { // is guest
      Auth.fetch(`${constants.DOMAIN}/api/v1/guest/shared/${postId}`, {
        mode: 'cors',
        method: 'GET',
      })
        .then(res => {
          this.setState({
            shared: res.sharedList.reverse(),
            navbar: <NavBar handleSearch={(search) => this.handleSearch(search)} signUp={this.toSignUp} login={this.toLogin} />,
            sidebar: <SelfSideBar user={res.post.user} />,
          })
        //   console.log('guestFavList', res);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
  
  profile(userId) {
    Auth.fetch(`${constants.DOMAIN}/api/v1/users/${userId}`, {
      mode: 'cors',
      method: 'GET',
    }).then(res => {
      this.setState({
        user: res.profile,
      }, () => {
        this.setState({ sidebar: <SelfSideBar user={this.state.user} /> });
      });
    })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    const searchUsers = this.state.shared.map(user =>
      (<UserQuery
        key={user._id}
        id={user._id}
        name={user.name}
        username={user.userName}
        bio={user.bio}
        rating={user.rating}
        profilePic={user.image}
        following={user.following}
      />));

    return (
      <div className="Post">
        <Helmet>
          <title>{`${this.state.shared.length} Shares`}</title>
        </Helmet>
        {this.state.navbar}
        <div style={{ position: 'relative' }} className="col-md-12 notifications-heading">
          <h3><i className="fa fa-retweet" />  Shared By</h3>
        </div>
        <div className="col-md-12 after-heading">
        </div>
        {this.state.sidebar}

        <div className="col-md-6 col-xs-12 productContainer">
          {searchUsers}
        </div>



      </div>
    );
  }
}

export default PostSharesList;
